export const LAO_BET_TYPES = {
  THREE_TOP: 'three_top',
  THREE_TOD: 'three_tod',
  TWO_TOP: 'two_top',
  TWO_BOTTOM: 'two_bottom',
  RUN_TOP: 'run_top',
  RUN_BOTTOM: 'run_bottom',
};

export const LAO_BET_TYPE_LABELS = {
  three_top: '3 ตัวบน',
  three_tod: '3 ตัวโต๊ด',
  two_top: '2 ตัวบน',
  two_bottom: '2 ตัวล่าง',
  run_top: 'วิ่งบน',
  run_bottom: 'วิ่งล่าง',
};

export const LAO_DEFAULT_BET_TYPES = [
  { id: 'three_top', label: '3 ตัวบน', digits: 3, multiplier: 850 },
  { id: 'three_tod', label: '3 ตัวโต๊ด', digits: 3, multiplier: 140 },
  { id: 'two_top', label: '2 ตัวบน', digits: 2, multiplier: 90 },
  { id: 'two_bottom', label: '2 ตัวล่าง', digits: 2, multiplier: 90 },
  { id: 'run_top', label: 'วิ่งบน', digits: 1, multiplier: 3.2 },
  { id: 'run_bottom', label: 'วิ่งล่าง', digits: 1, multiplier: 4.2 },
];

export const LAO_BET_TYPE_HINTS = {
  three_top: 'ท้าย 3 หลักตรงทุกตำแหน่ง',
  three_tod: 'ท้าย 3 หลัก สลับตำแหน่งได้',
  two_top: 'ท้าย 2 หลัก',
  two_bottom: '2 ตัวหน้าของเลข 4 ตัวท้าย',
  run_top: 'เลขใดเลขหนึ่งใน 3 ตัวบน',
  run_bottom: 'เลขใดเลขหนึ่งใน 2 ตัวล่าง',
};

export function laoDigitLength(betType) {
  if (betType === 'run_top' || betType === 'run_bottom') return 1;
  if (betType === 'two_top' || betType === 'two_bottom') return 2;
  return 3;
}

export function formatLaoCountdown(remainingTime) {
  if (!remainingTime) return '--:--:--';
  const { days, hours, minutes, seconds } = remainingTime;
  if (days > 0) {
    return `${days}ว ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function formatLaoPayout(multiplier) {
  const value = Number(multiplier);
  const pretty = Number.isInteger(value) ? String(value) : String(value);
  return `$${pretty} ต่อ $1`;
}

export function tickRemainingTime(prev) {
  if (!prev || prev.isExpired) return prev;
  let { days, hours, minutes, seconds } = prev;
  if (seconds > 0) seconds -= 1;
  else if (minutes > 0) {
    minutes -= 1;
    seconds = 59;
  } else if (hours > 0) {
    hours -= 1;
    minutes = 59;
    seconds = 59;
  } else if (days > 0) {
    days -= 1;
    hours = 23;
    minutes = 59;
    seconds = 59;
  } else {
    return { ...prev, isExpired: true };
  }
  return { days, hours, minutes, seconds, isExpired: false };
}

export function deriveLaoResult(six) {
  const padded = String(six || '').padStart(6, '0').slice(-6);
  const four = padded.slice(-4);
  return {
    six: padded,
    four,
    threeTop: padded.slice(-3),
    twoTop: padded.slice(-2),
    twoBottom: four.slice(0, 2),
  };
}

export function randomLaoNumber(length) {
  const max = 10 ** length;
  return Math.floor(Math.random() * max)
    .toString()
    .padStart(length, '0');
}
